import { render } from "./userConfig.vue?vue&type=template&id=39685fc0&scoped=true"
import script from "./userConfig.vue?vue&type=script&lang=js"
export * from "./userConfig.vue?vue&type=script&lang=js"

import "./userConfig.vue?vue&type=style&index=0&id=39685fc0&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39685fc0"]])

export default __exports__